import { create } from 'zustand';

export const useUIStore = create((set) => ({
  isMobile: false,
  isCollapsed: false,
  activeMenu: 'Home',

  setIsMobile: (val) => set({ isMobile: val }),
  setIsCollapsed: (val) => set({ isCollapsed: val }),
  setActiveMenu: (val) => set({ activeMenu: val }),
}));
